// components/MobileTabsCarousel.jsx
import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/MobileTabsCarousel.module.css";

export default function MobileTabsCarousel({ tabs, activeKey, onSelect }) {
  const listRef = useRef(null);
  const [centerX, setCenterX] = useState(0);

  useEffect(() => {
    const el = listRef.current;
    if (!el) return;
    const updateCenter = () => {
      const r = el.getBoundingClientRect();
      setCenterX(r.left + r.width / 2);
    };
    updateCenter();
    window.addEventListener("resize", updateCenter);
    return () => window.removeEventListener("resize", updateCenter);
  }, []);

  const updateActive = () => {
    const el = listRef.current;
    if (!el) return;
    const items = Array.from(el.querySelectorAll("[data-tab]"));
    let best = null;
    let bestDist = Infinity;
    items.forEach((node) => {
      const r = node.getBoundingClientRect();
      const c = r.left + r.width / 2;
      const dist = Math.abs(c - centerX);
      if (dist < bestDist) {
        bestDist = dist;
        best = node;
      }
    });
    items.forEach((n) => n.classList.toggle(styles.active, n === best));
  };

  const centerItem = (node) => {
    const el = listRef.current;
    if (!el || !node) return;
    const r = node.getBoundingClientRect();
    const er = el.getBoundingClientRect();
    const offset = (r.left + r.width / 2) - (er.left + er.width / 2);
    el.scrollBy({ left: offset, behavior: "smooth" });
  };

  useEffect(() => {
    updateActive();
    const t = setTimeout(updateActive, 60);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs, centerX]);

  return (
    <nav className={styles.bar}>
      <div
        className={styles.scroller}
        ref={listRef}
        onScroll={updateActive}
      >
        {tabs.map((t) => (
          <button
            key={t.key}
            data-tab
            className={`${styles.item} ${t.key === activeKey ? styles.current : ""}`}
            onClick={(e) => {
              onSelect(t.key);
              centerItem(e.currentTarget);
            }}
            title={t.label}
          >
            {t.icon && <img src={t.icon} alt="" aria-hidden="true" />}
            <span>{t.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
